<template>
  <div
    class="flex h-full flex-col overflow-hidden bg-background-fg/5"
  >
    <template v-if="$slots.header || $slots.title">
      <div
        :class="[
          'flex shrink-0 items-center px-4 pb-2 pt-4',
          hasContentAbove ? 'shadow-lg' : '',
        ]"
      >
        <slot name="header">
          <PageTitle>
            <slot name="title" />
          </PageTitle>
        </slot>
      </div>
    </template>
    <div
      ref="scrollContainerRef"
      class="h-full overflow-y-auto px-4 pb-4"
      :class="
        $slots.header || $slots.title ? 'pt-2' : 'pt-4'
      "
    >
      <div ref="scrollableRef" class="min-h-full">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useScroll } from "@vueuse/core"

const scrollContainerRef = useTemplateRef(
  "scrollContainerRef"
)
const scrollableRef = useTemplateRef("scrollableRef")
const { arrivedState } = useScroll(scrollContainerRef)

onMounted(() => {
  const element = scrollContainerRef.value
  if (element !== null) {
    arrivedState.top = element.scrollTop <= 0
    arrivedState.bottom =
      element.scrollTop + element.clientHeight >=
      element.scrollHeight - 1
    arrivedState.left = element.scrollLeft <= 0
    arrivedState.right =
      element.scrollLeft + element.clientWidth >=
      element.scrollWidth - 1
  }
})

const hasContentAbove = computed(() => !arrivedState.top)
// const hasContentBelow = computed(() => !arrivedState.bottom)
</script>
